// Copyright (c) 2025 WiseTime. All rights reserved.

import { t } from "@lingui/macro"
import { activateI18n } from "../../../locales/i18nUtil"
import {
  TimesheetField,
  TimesheetFieldLabelKey,
  TimesheetFieldOption,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

activateI18n()

export const wellKnownTimesheetFieldLabel: Partial<Record<TimesheetFieldLabelKey, string>> = {
  [TimesheetFieldLabelKey.TIMESHEET_FIELD_LABEL_KEY_ACTIVITY]: t({ id: "label_activity", message: "Activity" }),
  [TimesheetFieldLabelKey.TIMESHEET_FIELD_LABEL_KEY_PHASE]: t({ id: "label_phase", message: "Phase" }),
  [TimesheetFieldLabelKey.TIMESHEET_FIELD_LABEL_KEY_BILL_RATE]: t({ id: "label_bill_rate", message: "Bill Rate" }),
}

export const getTimesheetFieldLabel = (timesheetField: TimesheetField.AsObject): string =>
  timesheetField.label
  || wellKnownTimesheetFieldLabel[timesheetField.labelKeyType]
  || t({ id: "msg_timesheet_field", message: "Timesheet field" })

export const getTimesheetFieldOptionTitle = (
  timesheetFieldOption: TimesheetFieldOption.AsObject,
): string => {
  let externalId = timesheetFieldOption?.externalId
  if (externalId === undefined || externalId === "") {
    externalId = t({ id: "label_no_code", message: "No code." })
  }
  return `${timesheetFieldOption.label}\n${externalId}`
}
